import { createStore } from "vuex";
import VuexPersistence from "vuex-persist";
import * as actions from "./actions";
import * as mutations from "./mutations";
import { isUriseOnlyUser } from "@/utils/uriseAccess";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => {
    const {
      ucollabRedesignToggle: _ucollabRedesignToggle,
      ...persistedState
    } = state;
    return persistedState;
  }
});

export default createStore({
  plugins: [vuexLocal.plugin],
  state: {
    status: "",
    confirmationType: null,
    confirmationToken: null,
    token: localStorage.getItem("uwillToken") || null,
    isConfirmed: true,
    isIncomplete: false,
    user: {},
    isDashboard: false,
    isCollaborate: false,
    isOperator: false,
    isBasicNeedsSpecialist: false,
    isChangeover: false,
    ucollaborateViewPreference: null,
    ucollabRedesignToggle: false,
    therapists: null,
    invitation_code: null,
    needsTFA: false,
    callState: {
      state: "",
      stateClass: "",
      viewHeading: "",
      viewIcon: ""
    },
    screenerId: null,
    requestedItem: null,
    sessionSettings: {},
    optionalSettings: {},
    pendingBrcs: null,
    communitySearchZip: null,
    openInvitationModal: false,
    selectedPatient: null,
    selectedCrisisCall: null,
    providerSearchCriteria: null,
    providerSearchResults: null,
    providerSearchLoading: false,
    providerSearchError: null
  },
  mutations: mutations,
  actions: actions,
  getters: {
    confirmationType: state => state.confirmationType,
    confirmationToken: state => state.confirmationToken,
    isLoggedIn: state => !!state.token,
    isUriseOnly: state => isUriseOnlyUser(state.user),
    isIncomplete: state => state.isIncomplete,
    authStatus: state => state.status,
    isConfirmed: state => state.isConfirmed,
    isChangeover: state => state.isChangeover,
    isDashboard: state => state.isDashboard,
    isCollaborate: state => state.isCollaborate,
    isOperator: state => state.isOperator,
    isBasicNeedsSpecialist: state => state.isBasicNeedsSpecialist,
    ucollabRedesignToggle: state => state.ucollabRedesignToggle,
    optionalSettings: state => state.optionalSettings,
    messagingEnabled: state => !!state.optionalSettings.messaging,
    isLegacyUcollaborateView: state =>
      !state.ucollabRedesignToggle ||
      state.ucollaborateViewPreference === "legacy",
    therapists: state => state.therapists,
    providers: state => state.providers,
    invitation_code: state => state.invitation_code,
    needsTFA: state => state.needsTFA,
    mfaRequired: state => state.mfaRequired,
    requestToView: state => state.requestedItem,
    openInvitationModal: state => state.openInvitationModal,
    providerSearchCriteria: state => state.providerSearchCriteria,
    providerSearchResults: state => state.providerSearchResults,
    providerSearchLoading: state => state.providerSearchLoading,
    providerSearchError: state => state.providerSearchError
  },
  modules: {}
});
